<template>
	<div>
		<div v-if="!done" class="mdl-cell mdl-cell--12-col mdl-shadow--2dp">
			<div class="mdl-card fill">
				<div class="ga-form-title">
					<h2 class="ga-title-text">{{'register.emailconfirmation.label.title' | label}}</h2>
				</div>
				<div class="mdl-cell mdl-cell--12-col">
					{{'register.emailconfirmation.label.text' | label}}
				</div>
				<div class="mdl-card__actions">
					<div class="card-grid mdl-grid inner-grid">
						<div class="mdl-cell mdl-cell--4-col">
						</div>
						<div class="mdl-cell mdl-cell--4-col">
						</div>
						<div class="mdl-cell mdl-cell--4-col">
							<div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
										v-on:click="reSendDelayedVerification()">
								{{'register.emailconfirmation.button.send' | label}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    <div v-show="done" class="card-page-container"  >
      <div class="mdl-grid">
        <div class="mdl-layout-spacer"></div>
        <div class="mdl-cell fill mdl-shadow--2dp">
          <alert title="register.verify.alt-message.title" message="register.verify.message.text" @click="logout"></alert>
        </div>
        <div class="mdl-layout-spacer"></div>
      </div>
    </div>
	</div>
</template>

<script>
var api = require('api')
var getters = require('common/store/getters')
export default {
  vuex: {
    getters: getters
  },
  methods: {
    reSendDelayedVerification () {
      var self = this
      api.User.reSendDelayedVerification({id: this.user.id}).then(function () {
        self.done = true
      }, function (err) {
        console.error(err)
      })
    },
    logout () {
      this.$dispatch('logout')
    }
  },
  components: {
    alert: require('c/components/Alert')
  },
  data: function () {
    return {
      done: false
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// SendDelayedVerification.vue?a8d52cf0